import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import SpecialEducationSupportDetails from '../../subdepartmentdetails/SpecialEducationSupport'


function SpecialEducationSupport() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Special Education and Learning Support Services || Education";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Education Youth Services"
            title="Special Education Support"
            subtitledown="Department of Education"
           />
            <SpecialEducationSupportDetails/>
        </div>
    </>
  )
}

export default SpecialEducationSupport